import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Case, CaseStatus } from "../../../stores/CaseStore/types";
import "./CaseItem.scss";
import { provinceCodeToName } from "./utils";
import useTranslation from "../../../hooks/useTranslation";
import { useNavigate } from "react-router-dom";
import authStore from "../../../stores/AuthStore";
import { UserRoles } from "../../../stores/AuthStore/types";
import { Offer } from "../../../stores/OfferStore/types";
import OfferResultDialog from "../../Offer/OfferResultDialog";
import offerStore from "../../../stores/OfferStore";
import { parseDate } from "../../../utils/helperFunctions";

interface CaseProps {
  caseItem: Case;
  offers?: Offer[];
}

const CaseItem = observer(({ caseItem, offers }: CaseProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [caseOffers, setCaseOffers] = useState<Offer[]>();
  const [openOfferResultDialog, setOpenOfferResultDialog] = useState(false);

  useEffect(() => {
    if (offerStore.userOffers?.length && caseItem?.id) {
      setCaseOffers(
        offerStore.userOffers.filter(
          (offer) => offer.caseId.toString() === caseItem?.id?.toString()
        )
      );
    }
  }, [caseItem?.id, offerStore.userOffers]);

  const handleCaseItemClick = () => {
    if (!openOfferResultDialog) {
      if (caseItem.ownerRole === UserRoles.LAWYER) {
        navigate(`/delegation/${caseItem.id}`);
      } else {
        navigate(`/case/${caseItem.id}`);
      }
    }
  };

  const handleOfferItemClick = (
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenOfferResultDialog(true);
  };

  return (
    <div className="caseItem" onClick={handleCaseItemClick}>
      <header>
        <h5>
          {caseItem.ownerId === authStore.user.id ? (
            <>
              <i className={`fas fa-circle ${caseItem.status.toLowerCase()}`} />
              {t(caseItem.status.toLowerCase())}
            </>
          ) : (
            <span>{t(caseItem.type)}</span>
          )}
        </h5>
        <span>{parseDate(caseItem.updateDate)}</span>
      </header>
      <main>
        {caseItem.rejectReason && caseItem.status === CaseStatus.REJECTED ? (
          <span className="rejectReason">{caseItem.rejectReason}</span>
        ) : (
          <i>
            - &quot;{caseItem.description}
            &quot;
          </i>
        )}
      </main>
      <footer>
        <span>
          <i className="fal fa-map-marker-alt"></i>
          &nbsp;
          {provinceCodeToName(caseItem.caseProvince)}
        </span>
        {caseItem.ownerId === authStore.user.id && (
          <span onClick={(e) => handleOfferItemClick(e)}>
            <i className="fal fa-hand-holding-usd"></i>&nbsp; {t("offers")}:{" "}
            {offers?.length || "0"}
          </span>
        )}
      </footer>
      {caseItem && caseOffers && (
        <OfferResultDialog
          offers={caseOffers}
          open={openOfferResultDialog}
          setOpen={setOpenOfferResultDialog}
        />
      )}
    </div>
  );
});

export default CaseItem;
